import React from 'react'
import { t } from 'ttag'

import Illustration from 'components/common/Illustration'
import { Box } from 'components/layout/Box/Box'
import { Description } from 'components/modals/TestsReportModal/common/Description/Description'
import { ScoreChip } from 'components/shared/ScoreChip/ScoreChip'
import { Traits } from './common/Traits/Traits'
import cx from 'classnames'
import { getFactorScoreTreshholds } from 'utils/score'
import { percentScore } from 'utils/stringFormat'
import { useFactorState } from './hooks'
import DistributionSVG from 'images/illustrations/distribution'

import styles from './Factor.module.scss'

export const Factor = ({
  factor,
  language,
  scores,
  minimize = false,
  stats = null,
  wrap = true,
}) => {
  const { state, handlers } = useFactorState({
    factor,
    language,
    scores,
    stats,
  })

  const {
    abstract,
    attributes,
    correct,
    description,
    label,
    score,
    time,
    totalAnswers,
    totalQuestions,
    traits,
    traitsCount,
    isAllOpened,
  } = state
  const { handleToggle, handleToggleAll } = handlers

  return (
    <Box
      className={cx(styles.factor, {
        [styles.minFactor]: minimize,
      })}
    >
      <Box
        className={cx(styles.description, {
          [styles.minDescription]: minimize,
        })}
        direction="column"
      >
        <Box
          align="center"
          className={cx(styles.header, {
            [styles.minHeader]: minimize,
          })}
          justify="space-between"
        >
          <h3 className={styles.title}>{label}</h3>
          <ScoreChip
            score={percentScore(score)}
            size={minimize ? 'medium' : 'large'}
            theme={getFactorScoreTreshholds(score)}
          />
        </Box>
        {factor === 'GMA' ? (
          <p className={styles.text}>
            {t`The candidate answered ${totalAnswers} of ${totalQuestions} questions and used ${time}. The candidate had ${correct} correct answers.`}
          </p>
        ) : null}
        <Description text={abstract} />
        <Description text={description} />
        <DistributionSVG />
      </Box>
      {traitsCount > 0 ? (
        <Traits
          {...{
            attributes,
            label,
            language,
            scores,
            traits,
            traitsCount,
            handleToggle,
            handleToggleAll,
            isAllOpened,
            wrap,
          }}
        />
      ) : (
        <Illustration
          className={styles.image}
          name="report"
          alt="Placeholder"
        />
      )}
    </Box>
  )
}
